import { Component, OnInit, Output, Input, EventEmitter, ViewChild, ChangeDetectorRef, AfterViewChecked } from '@angular/core';
import { ExternalUserService } from '@externaluserservice/external-user.service';
import { Station, AccountExecutives, AdvancePaymentstationsDetails, StationList, advancePaymentInfo  } from '@externalusermodel/AdvancePayment';
import { FormGroup, FormControl, Validators, FormBuilder } from '@angular/forms';
import { AdvanceDetailsComponent } from '@advancedetailcompenent/advance-details.component';
import { Router, ActivatedRoute } from '@angular/router';
import { Table } from 'primeng/table';
import { DatePipe } from '@angular/common';
import { authManager } from '@authmanager/authManager';
import { HttpClient } from '@angular/common/http';
import { AdminService } from '@adminservice/admin.service';
import { SelectedRecords, TransactionHistory } from '@externalusermodel/Order';
import { AdvancePaymentDetails } from '@externalusermodel/AdvancePaymentDetails';
import { Invoice } from '@externalusermodel/Invoice';
import { SafeResourceUrl, DomSanitizer } from '@angular/platform-browser';
import { AgencyDetail } from '@externalusermodel/AgencyDetail';
import { ConfirmationService } from 'primeng/api';
import { ConfirmDialogModule } from 'primeng/confirmdialog';


declare var jquery:any;
declare var $ :any;

@Component({
  selector: 'app-external-user',
  templateUrl: './external-user.component.html',
  styleUrls: ['./external-user.component.css'],
  providers: [ExternalUserService, AdminService,ConfirmationService],

})
export class ExternalUserComponent implements AfterViewChecked, OnInit {

  @ViewChild('dt') private _invoiceTable: Table;
  @ViewChild('dtr') private _ordersTable: Table;

  // childTitle:string = "This text is passed to child";
  AdvanceAmount: any;
  station: any;
  accountExecutive: any;
  comments: any;
  invalidStation: boolean;
  invalidAccountEx: boolean;
  // Arvind added agency in Advance page.
  invalidAgency: boolean;
  // End
  invalidComments: boolean;
  invalidAdvanceAmnt: boolean;
  invalidAdvanceAmntInGrid: boolean;
  advcPayNowBtn: boolean;
  loadingInvoice: boolean;
  loadingOrder: boolean;
  loadingOrderInvoicepopup: boolean;
  commentstxt: any;
  stationtxt: any;
  accountExtxt: any;
  amounttxt: any;
  isStationExist:boolean;

  Invoice: any = [];
  ShowInvoice: boolean;
  ShowOrder: boolean;
  ShowAdvancePayment: boolean;
  Orders: any = [];
  loading: boolean;
  data: any[];
  selectedItems: any[];
  selectedInvoiceID: any[] = [];
  totalamount: number;
  redirectToInvoiceDetailUrl: any;
  advance: any[] = [];
  stations: any[];
  isFromAdvance: any;
  tmpComments: any;
  tmpamount: any;
  tmpadvanceAmount: any;
  accountExecutives: AccountExecutives[];
  model: any[] = [];
  advanceDetails: boolean;
  agencyName: string;
  //Arvind added agency for Advance page.
  agencyAdvancename:string;
  //End
  OrderTotalAmount: number;
  selectedOrderID: any[] = [];
  OderagencyName: string;
  AgencyID: string;
  OrderagencyID: string;
  invoiceBtn: boolean;
  orderBtn: boolean;
  orderInvoiceBtn: boolean;
  isOderDeatails: string;
  OrderRelatedInvoiceId: string;
  OrderInvoice: any = [];
  agencyid: string;
  SelectedStations: any;
  SelectedExecutive: any;
  selectedToPayInvoice: any = {};
  isDatapresent: boolean;
  agency_Comm: string;
  tax: any;
  isFilterEnable: boolean;
  isFilterEnableOrder: boolean;
  StationListInitial: any;

  // filtering

  enableInvoiceFilter: boolean;
  isInvoice_InvoiceFilterEndDateDisabled: boolean;
  invoice_InvoiceFilterStartDate: any;
  invoice_InvoiceFilterEndDate: any;

  isInvoice_DueFilterEndDateDisabled: boolean;
  invoice_DueFilterStartDate: any;
  invoice_DueFilterEndDate: any;

  enableOrdersFilter: boolean;
  isOrder_ordFilterEndDateDisabled: boolean;
  orders_ordFilterStartDate: any;
  orders_ordFilterEndDate: any;

  LognewUser: any = {};
  UserLog: string;
  require: any;
  LnewUser: any = {};
  UserLogStatus: any = [];
  Recordsselected = [];
  Sourcefrom: string;
  IsinvoicedFlag: boolean;

  selectedOrderInvoiceMap: Map<string, TransactionHistory> = new Map<string, TransactionHistory>();
  selectedInvoiceMap: Map<string, TransactionHistory> = new Map<string, TransactionHistory>();
  selectedOrderMap: Map<string, TransactionHistory> = new Map<string, TransactionHistory>();

  userId: number;

  userAgencyData: any;
  AgencyDetail: any = {};
  agencyID: string;

  selectedUserAgency: any = '';
  somePlaceholder: any = '';

  showAddStationRow: boolean;
  display: boolean;
  urlSafe: SafeResourceUrl;

  hideOrderInvoice: boolean;
  isAgencyUnassigned: any;

	showIframe: boolean = false;
  fileNotFound: boolean = false;
  fileLoading: boolean = false;

   AdvancePaymentstationsDetails: any = {};
  loadingStationGrid: boolean;
   StationList: any = [];
  saveRow: boolean;
  cancelRow: boolean;
  disableINeditBtn: boolean = false;
  disableINdeleteBtn: boolean = false;
  disableINUpdateBtn: boolean = false;
  ShowaddStation: boolean = false;
  advancePaymentInfo: advancePaymentInfo;
  SumStationAmount:number;
  
  AdvancepaymentID: number;
  AdvancepaymentcreatedID: string;
  CheckAddStation: boolean = true;
  isStationExistInGrid: boolean;
  ShowpaynowBtn: boolean;

  accountFlag: boolean;
  exceededAdvanceAmnt: boolean;
  exceededAdvanceAmntInGrid: boolean;
  // Arvind Advance Payment for agency commission
  paymenttype: string;
  InvalidAmount: boolean;
  isLoading: boolean = true;
  orderAgencyDetail: any= [];
  Advancetotalamount: number;
  // isChecked: boolean = false;
  isCheckedAgency:boolean= false;
  //isChecked: boolean;
  isPayment: boolean;
  isCheckedBOX: boolean=false;
  isTaxChecked:boolean= false;
  ShowTaxCheckBox: boolean;
  isTaxCheckedBOX:boolean =false;
  //Arvind End
  hideColums: boolean;
  //Arvind End

  constructor(private externalUserService: ExternalUserService, private router: Router,
    private authManagerService: authManager, private route: ActivatedRoute, public datepipe: DatePipe, private http: HttpClient,
    private adminService: AdminService, public changeDetectorRef:ChangeDetectorRef, public sanitizer: DomSanitizer,private confirmationService: ConfirmationService) {


    this.totalamount = 0;
    this.OrderTotalAmount = 0;
    this.invalidStation = true;
    this.invalidAccountEx = true;
    // Arvind added for agency for Advance page
     this.invalidAgency = true;
    // End
    this.invalidComments = true;
    this.invalidAdvanceAmnt = true;
    this.invalidAdvanceAmntInGrid = true;
    this.isAgencyUnassigned = '1';
    this.display = false;
    this.showAddStationRow = false;
    this.enableInvoiceFilter = false;
    this.isInvoice_InvoiceFilterEndDateDisabled = true;
    this.isInvoice_DueFilterEndDateDisabled = true;
    this.enableOrdersFilter = false;
    this.isOrder_ordFilterEndDateDisabled = true;
    this.isOderDeatails = '';
    this.isFilterEnable = false;
    this.isFilterEnableOrder = false;
    this.isStationExist = false;
    this.isStationExistInGrid = false;

    this.accountFlag = false;
    this.exceededAdvanceAmnt = true;
    this.exceededAdvanceAmntInGrid = true;

  }

  viewFile(id: string) {
    //debugger;
    if (id != null) {
      this.showIframe = false;
      this.fileNotFound = false;
      this.fileLoading = false;

      this.display = true;

      this.fileLoading = true;

      this.externalUserService.getDownloadUrl(id).subscribe(response => {
        //debugger;
        if (response) {
          this.fileLoading = false;
          this.showIframe = true;
          this.urlSafe = this.sanitizer.bypassSecurityTrustResourceUrl(response);
        }
        else {
          this.fileLoading = false;
          this.fileNotFound = true;
        }

      });


    }

  }
  ngAfterViewChecked(){
      this.disableProcessingBox();
  }
  ngOnInit() {
    debugger;
// Arvind for Tax checkbox
   this.isTaxChecked =JSON.parse(sessionStorage.getItem('taxcheckbox'));
   if (this.isTaxChecked == undefined || this.isTaxChecked == null || this.isTaxChecked == false)
   {
    this.isTaxChecked = false;
    
   }
   else
   {
     this.isTaxChecked = true;
     this.isTaxCheckedBOX = true;
             
   }
    // console.log(this.isTaxChecked + 'Test');
     this.isCheckedAgency =JSON.parse(sessionStorage.getItem('comissioncheckbox'));
     this.hideColums = true;
     
    if (this.isCheckedAgency == true)
    {
     this.isCheckedBOX = true;
    }
    else
    {
      this.isCheckedBOX = false;
      this.isCheckedAgency= false;
    }
    this.accountFlag = false;
    setTimeout(() => {
      this.accountExtxt = JSON.parse(sessionStorage.getItem('selectedAccExe'));
      this.accountFlag = true;
    },100);
    this.AdvancepaymentcreatedID = sessionStorage.getItem('advanceID');
    if (this.AdvancepaymentcreatedID == "0") {
      this.accountExtxt = null;
    }
    this.GetStationGrid();
    this.ShowaddStation = false;
    this.getAccountExecutives();
    this.ShowpaynowBtn = false;
    this.getPayInformation();

    var self = this;
    setTimeout(() => {
      //debugger;
      self.selectedUserAgency = JSON.parse(sessionStorage.getItem("agencyData"));
    }, 0);

    this.agencyid = sessionStorage.getItem('AgencyID');

    //debugger;
    this.userId = +sessionStorage.getItem('userid');

    let r = this.router.url;


    this.externalUserService.getAgencyList(this.userId).subscribe(
      p => {
        //debugger;
        //console.log("P " + p);
        this.AgencyDetail = p;
        //debugger;
      }
    );

     //filtering

     this._invoiceTable.filterConstraints['inv_invDate'] = (value, filter): boolean => {
      // debugger;

      let startDate = new Date(this.datepipe.transform(filter[0], 'yyyy-MM-dd'));
       let endDate = new Date(this.datepipe.transform(filter[1], 'yyyy-MM-dd'));

       let rowDate = new Date(value);

     return (rowDate >= startDate && rowDate <= endDate);

     };

     this._invoiceTable.filterConstraints['inv_dueDate'] = (value, filter): boolean => {
       //  debugger;

       let startDate = new Date(this.datepipe.transform(filter[0], 'yyyy-MM-dd'));
      let endDate = new Date(this.datepipe.transform(filter[1], 'yyyy-MM-dd'));

      let rowDate = new Date(value);

      return (rowDate >= startDate && rowDate <= endDate);

     };


    this._ordersTable.filterConstraints['ord_ordDate'] = (value, filter): boolean => {

      let startDate = new Date(this.datepipe.transform(filter[0], 'yyyy-MM-dd'));
      let endDate = new Date(this.datepipe.transform(filter[1], 'yyyy-MM-dd'));

      let rowDate = new Date(value);

      return (rowDate >= startDate && rowDate <= endDate);
    };


    this.invoiceBtn = false;
    this.orderBtn = false;
    this.loadingOrderInvoicepopup = false;
    this.getStations();
    this.getAccountExecutives();
    this.isOderDeatails = this.route.snapshot.paramMap.get('isOderDeatails');

    if (this.isOderDeatails === 'invoice') {
      let divToChange = document.getElementById('id1');
       divToChange.className = 'active';

       let oneA = document.getElementById('1a');
       oneA.className = 'tab-pane active';

       let twoA = document.getElementById('2a');
       twoA.className = 'tab-pane';

      let threeA = document.getElementById('3a');
      threeA.className = 'tab-pane';

    } else if (this.isOderDeatails === 'order') {
      let divToChange = document.getElementById('id2');
      divToChange.className = 'active';

       let oneA = document.getElementById('1a');
      oneA.className = 'tab-pane';

      let twoA = document.getElementById('2a');
      twoA.className = 'tab-pane active';

      let threeA = document.getElementById('3a');
      threeA.className = 'tab-pane';
    } else if (this.isOderDeatails === 'advance') {
      let divToChange = document.getElementById('id3');
      divToChange.className = 'active';

       let oneA = document.getElementById('1a');
       oneA.className = 'tab-pane';

      let twoA = document.getElementById('2a');
      twoA.className = 'tab-pane';

      let threeA = document.getElementById('3a');
      threeA.className = 'tab-pane active';
// Arvind added ischeck to session 
     //this.isChecked = sessionStorage.get('comissioncheckbox');
      this.stationtxt = sessionStorage.getItem('station');
      this.SelectedStations = sessionStorage.getItem('station');
      this.accountExtxt = sessionStorage.getItem('accountExecutive');
      this.SelectedExecutive = sessionStorage.getItem('accountExecutive');
      this.commentstxt = sessionStorage.getItem('comments');
      //Arvind add agency for advance page
      this.selectedUserAgency = sessionStorage.getItem('agencyID');
      //End Arvind
      this.amounttxt = sessionStorage.getItem('advanceAmount');
      if ((this.SelectedStations === undefined) || (this.SelectedStations === 'undefined')) {
        this.SelectedStations = 'Select Stations';
      }
      if ((this.SelectedExecutive === undefined) || (this.SelectedExecutive === 'undefined')) {
        this.SelectedExecutive = 'Select Account Executive';
      }

    } else {
      sessionStorage.removeItem('station');
      sessionStorage.removeItem('isFromAdvance');
      sessionStorage.removeItem('comments');

      sessionStorage.removeItem('accountExecutive');

      let divToChange = document.getElementById('id1');
      divToChange.className = 'active';

       let oneA = document.getElementById('1a');
       oneA.className = 'tab-pane active';

      let twoA = document.getElementById('2a');
      twoA.className = 'tab-pane';

      let threeA = document.getElementById('3a');
      threeA.className = 'tab-pane';

    }

    if (sessionStorage.getItem('AgencyID') && sessionStorage.getItem('isAgencyUnassigned') != this.isAgencyUnassigned) {
      let agencyID = sessionStorage.getItem('AgencyID');
      this.ShowInvoice = true;
      this.AgencyID = agencyID;
      this.selectedUserAgency = sessionStorage.getItem('AgencyID');
      this.GetInvoiceGrid(agencyID);
      this.GetOrderGrid(agencyID);
    }
    else if (sessionStorage.getItem('isAgencyUnassigned') === this.isAgencyUnassigned) {
      this.hideOrderInvoice = true;
      let divToChange = document.getElementById('id3');
      divToChange.className = 'active';

       let invoiceTab = document.getElementById('1a');
       invoiceTab.className = 'tab-pane';

      let orderTab = document.getElementById('2a');
      orderTab.className = 'tab-pane';

      let advPaymntTab = document.getElementById('3a');
      advPaymntTab.className = 'tab-pane active';

    }

    this.saveIP();
  }
  GetInvoiceGrid(agency) {
    this.loadingInvoice = true;
    this.externalUserService.GetInvoiceGrid(agency).subscribe(
      p => { this.Invoice = p, this.loadingInvoice = false; }
    );


  }

  showInvoice() {
    this.ShowInvoice = true;
    this.ShowOrder = false;
    this.ShowAdvancePayment = false;
    this.SelectedStations = 'Select Stations';
    this.SelectedExecutive = 'Select Account Executive';
    sessionStorage.setItem("advanceID", "0");
    this.SumStationAmount = 0;
    this.commentstxt = "";
    this.accountExtxt = null;



   }
  OrdersTab() {
    this.SelectedStations = 'Select Stations';
    this.SelectedExecutive = 'Select Account Executive';
    sessionStorage.setItem("advanceID", "0");
    this.SumStationAmount = 0;
    this.commentstxt = "";
    this.accountExtxt = null;

  }
  showOrder() {

    this.ShowInvoice = false;
    this.ShowOrder = true;
    this.ShowAdvancePayment = false;

  }
  showAdvancePayment() {
    this.ShowInvoice = false;
    this.ShowOrder = false;
    this.ShowAdvancePayment = true;

  }
  GetOrderGrid(agency) {

    this.loadingOrder = true;
    this.externalUserService.GetOrderGrid(agency).subscribe(
      p => {
        this.Orders = p, this.loadingOrder = false;
        if (p.length > 0)
          this.agency_Comm = p[0]['agency_comm'];
      }
    );
    //console.log(this.Orders);
  }

  InvoiceDetail(event) {
    this.invoiceBtn = !this.invoiceBtn;
    let selectedInvoices: any = [];

    this.selectedInvoiceMap.forEach((value: TransactionHistory) => {
      selectedInvoices.push(value);
    });

    this.externalUserService.saveTransactionHistory(selectedInvoices).subscribe(
      p => {
        this.router.navigate(['InvoiceDetail', p]);
      }
    );

  }

  onInvoiceRowSelect(event) {

    //debugger;

    if(event.data.status == "Payment Processing")
      {
        event.onRowEditSelect = false;   
        event.onRowSelect = false;
      }
      else
        {

    let newRow = new TransactionHistory();
    newRow.orderId = event.data.orderId;
    newRow.invoiceId = event.data.invoiceID;
    newRow.invoiceDate = event.data.invoiceDate;
    newRow.agencyId = +this.agencyid;
    newRow.advertiserId = event.data.advertiserId;
    newRow.dueDate = event.data.invoiceDueDate;
    newRow.totalAmount = event.data.invoiceAmount;
    newRow.createdBy = this.userId;
    // Arvind for Station Name in report 
    newRow.station = event.data.propertyOrStationName;
    
    this.selectedInvoiceMap.set(event.data.invoiceID, newRow);

    if (newRow.totalAmount != null && newRow.totalAmount > 0) {
      this.invoiceBtn = true;
    }
        }
  }
  onRowInvoiceUnselect(event) {

    if (this.selectedInvoiceMap.has(event.data.invoiceID)) {
      let loopStatus = 1;
      this.selectedInvoiceMap.delete(event.data.invoiceID);
      this.selectedInvoiceMap.forEach((value: TransactionHistory, key: any) => {
        if (loopStatus) {
          let amount = new TransactionHistory();
          amount.totalAmount = value.totalAmount;
          if (amount.totalAmount > 0) {
            this.invoiceBtn = true;
            loopStatus = 0;
          }
        }
      });
      if (this.invoiceBtn === true && loopStatus !== 0) {
        this.invoiceBtn = !this.invoiceBtn;
      }
    }

    if (this.selectedInvoiceMap.size === 0) {
      this.invoiceBtn = false;
    }

  }

  invoiceFilterToggle(event) {
    this.isFilterEnable = !this.isFilterEnable;
    //console.log(this.isFilterEnable);

    this.enableInvoiceFilter === false ? this.enableInvoiceFilter = true : this.enableInvoiceFilter = false;
    if (!this.enableInvoiceFilter) {
      this._invoiceTable.reset();
      this.isInvoice_InvoiceFilterEndDateDisabled = true;
      this.isInvoice_DueFilterEndDateDisabled = true;
    }
  }

  ordersFilterToggle(event) {
    this.isFilterEnableOrder = !this.isFilterEnableOrder;
    this.enableOrdersFilter === false ? this.enableOrdersFilter = true : this.enableOrdersFilter = false;
    if (!this.enableOrdersFilter) {
      this._ordersTable.reset();
      this.isOrder_ordFilterEndDateDisabled = true;
    }

  }
  selectedInvoice(event) {
    this.selectedItems;
  }

  //to make checkbox invisible
  disableProcessingBox(){
    $("#externalUserTable tr").each(function () {
      var tddata = $(this).find("td:eq(10)");
      var img = tddata.find('img').attr('src');
        if (tddata.find('img').attr('src') && img=='/assets/images/processing.png') {
          $(this).find('p-dtcheckbox').remove();
        }
    })

    $("#orderInvoiceTable tr").each(function () {
      var tddata = $(this).find("td:eq(10)");
      var img = tddata.find('img').attr('src');
        if (tddata.find('img').attr('src') && img=='/assets/images/processing.png') {
          $(this).find('p-dtcheckbox').remove();
        }
    })


  }
  invoiceHeaderCheckBoxToggle(selectedItems) {

    this.invoiceBtn = false;



    if (this.selectedInvoiceMap.size > 0) {
      this.selectedInvoiceMap.clear();
    }

    if (selectedItems.length > 0) {
      selectedItems.forEach(element => {
        if (element.status == "Payment Processing")
         {
          element.onRowEditSelect = false;
          }
          else
            {
        let newRow = new TransactionHistory();
        newRow.orderId = element.orderId;
        newRow.invoiceId = element.invoiceID;
        newRow.invoiceDate = element.invoiceDate;
        newRow.agencyId = +this.agencyid;
        newRow.advertiserId = element.advertiserId;
        newRow.dueDate = element.invoiceDueDate;
        newRow.totalAmount = element.invoiceAmount;
        newRow.createdBy = this.userId;

        this.selectedInvoiceMap.set(element.invoiceID, newRow);
        if (newRow.totalAmount != null && newRow.totalAmount > 0) { this.invoiceBtn = true; }
      }

      }
  );


    }


  }

  // method to get station
  getStations() {

    this.externalUserService.getStations().subscribe(
      p => {
        this.stations = p;
       // console.log(this.stations);
      }
    );
  }
  // method to get account executives
  getAccountExecutives() {
    this.externalUserService.getAccountExecutives().subscribe
      (p => {
        this.accountExecutives = p;
       // console.log(this.accountExecutives);
      });

  }
  onAdvanceClick(myForm) {
   // debugger;
    // Arvind
sessionStorage.removeItem('comissioncheckbox');
//Arvind Tax checkbox
sessionStorage.removeItem('taxcheckbox');
// End
    this.accountExtxt = null;

    this.invalidStation = true;
    this.invalidAccountEx = true;
    // Arvind added for agency for Advance page
    this.invalidAgency = true;
    // End
    this.invalidComments = true;
    this.invalidAdvanceAmnt = true;
    this.invalidAdvanceAmntInGrid = true;
    this.ShowpaynowBtn = false;
    // Arvind Tax checkbox
    this.ShowTaxCheckBox = false;
    for (let name in myForm.controls) {
      if (myForm.controls.hasOwnProperty(name)) {
        myForm.controls[name].reset();
      }
    }
    this.SelectedStations = 'Select Stations';
    this.SelectedExecutive = 'Select Account Executive';
    this.GetStationGrid();
    this.getPayInformation();

  }
  // Method to pay now on Advance Payment Screen
  onPayNowClick(myForm) {

    if (myForm.valid) {
      this.invalidStation = true;
      this.invalidAccountEx = true;
      // Arvind added for agency for Advance page
     this.invalidAgency = true;
     // End
      if (myForm.controls.comments.valid) {
        if (myForm.controls.comments.value.trim().length > 0) {
          this.invalidComments = true;
        } else { this.invalidComments = false; }
      }
      if (myForm.controls.amount.valid) {
        if (myForm.controls.amount.value > 0) {
          this.invalidAdvanceAmnt = true;
        } else if (myForm.controls.amount.value < 0) {
          this.invalidAdvanceAmnt = false;
        } else {
          this.invalidAdvanceAmnt = false;
        }
      }
      // Arvind added condition for agency for Advance page (&& this.invalidAgency === true)

      if (this.invalidStation === true && this.invalidAdvanceAmnt === true && this.invalidComments === true && this.invalidAccountEx === true && this.invalidAgency === true) {
        this.AdvanceAmount = myForm.controls.amount.value;
        this.station = myForm.controls.station.value;
        this.accountExecutive = myForm.controls.accountEx.value;
        this.comments = myForm.controls.comments.value;
        this.advanceDetails = false;
	// Arvind added for agency details in advance page
        this.agencyAdvancename = myForm.controls.agencydetail.value;
        this.isCheckedAgency = myForm.controls.Agencycheckbox.value;

        //Arvind for Tax checkbox
        this.isTaxChecked = myForm.controls.Taxcheckbox.value;
        

        // debugger;
        let details = new AdvancePaymentDetails();

        details.stationId = this.station.stationID;
        details.accountExecutiveId = this.accountExecutive.id;
        details.externalUserComments = this.comments;
        details.totalAmount = this.AdvanceAmount;
        details.createdBy = this.userId;
        // Arvind added Agency for Advance page.
        details.agencyAdvance = this.selectedUserAgency.agencyID;

        this.externalUserService.saveAdvancePaymentDetails(details).subscribe(
          p => {
            // debugger;
            let response = p;
            this.router.navigate(['AdvanceDetail', response]);
          }
        );
      }
    } else {
      // this.advcPayNowBtn=true;
      if (!myForm.controls.station.valid) {
        this.invalidStation = false;
      }
      if (myForm.controls.station.valid) {
        this.invalidStation = true;
      }
      if (!myForm.controls.accountEx.valid) {
        this.invalidAccountEx = false;
      }
      if (myForm.controls.accountEx.valid) {
        this.invalidAccountEx = true;
      }

      // Arvind added for agency in advance page
      if (!myForm.controls.agencydetail.valid) {
        this.invalidAgency = false;
      }
      if (myForm.controls.agencydetail.valid) {
        this.invalidAgency = true;
      }
      // End

      if (!myForm.controls.comments.valid) {
        this.invalidComments = false;
      }
      if (myForm.controls.comments.valid) {
        if (myForm.controls.comments.value.trim().length > 0) {
          this.invalidComments = true;
        } else { this.invalidComments = false; }
      }
      if (!myForm.controls.amount.valid) {
        this.invalidAdvanceAmnt = false;
      }
      if (myForm.controls.amount.valid) {
        if (myForm.controls.amount.value === 0) {
          this.invalidAdvanceAmnt = false;
        } else if (myForm.controls.amount.value < 0) {
          this.invalidAdvanceAmnt = false;
        } else {
          this.invalidAdvanceAmnt = true;
        }
      }
    }
  }

  onAdvancePaymentPayNow() {
    let advancePaymentDetailsId = sessionStorage.getItem('advanceID');
    this.externalUserService.saveAdvancePaymentDetails(advancePaymentDetailsId).subscribe(
      p => {
        //debugger;
        let response = p;
        this.router.navigate(['AdvanceDetail', response]);
      }
    );
  }

  // order relate functions

  onOrderRowSelect(event) {
    //debugger;
    let newRow = new TransactionHistory();
    newRow.orderId = event.data.order_id;
    newRow.orderDate = event.data.flight_start_dt;
    newRow.agencyId = +event.data.agencyId;
    newRow.advertiserId = event.data.advertiserId;
    newRow.totalAmount = event.data.total_order_amount;
    newRow.createdBy = this.userId;
    newRow.agencyComm = event.data.agency_comm; //this.agency_Comm;
    newRow.tax = event.data.tax1_rate;
    // Arvind for Station Name in report 
    newRow.station = event.data.station_name;
    this.selectedOrderMap.set(event.data.order_id, newRow);

    if (newRow.totalAmount != null && newRow.totalAmount > 0) {
      this.orderBtn = true;
    }


  }

  onRowOrderUnselect(event) {
    if (this.selectedOrderMap.has(event.data.order_id)) {
      let loopStatus = 1;
      this.selectedOrderMap.delete(event.data.order_id);
      this.selectedOrderMap.forEach((value: TransactionHistory, key: any) => {
        if (loopStatus) {
          let amount = new TransactionHistory();
          amount.totalAmount = value.totalAmount;
          if (amount.totalAmount > 0) {
            this.orderBtn = true;
            loopStatus = 0;
          }
        }
      });
      if (this.orderBtn === true && loopStatus !== 0) {
        this.orderBtn = !this.orderBtn;
      }
    }

    if (this.selectedOrderMap.size === 0) {
      this.orderBtn = false;
    }
  }


  OrderDetail(event) {

    // debugger;
    this.orderBtn = !this.orderBtn;
    let selectedOrders: any = [];

    this.selectedOrderMap.forEach((value: TransactionHistory) => {
      selectedOrders.push(value);
    });
    // debugger;
    this.externalUserService.saveTransactionHistory(selectedOrders).subscribe(
      p => {
        this.router.navigate(['OrderDetail', p]);
      }
    );
  }
  orderHeaderCheckBoxToggle(selectedOrderItems) {

    // debugger;
    this.orderBtn = false;

    if (this.selectedOrderMap.size > 0) {
      this.selectedOrderMap.clear();
    }

    if (selectedOrderItems.length > 0) {
      selectedOrderItems.forEach(element => {
        let newRow = new TransactionHistory();

        newRow.orderId = element.order_id;
        newRow.orderDate = element.flight_start_dt;
        newRow.agencyId = +element.agencyId;
        newRow.advertiserId = element.advertiserId;
        newRow.totalAmount = element.total_order_amount;
        newRow.createdBy = this.userId;
        newRow.agencyComm = this.agency_Comm;
        newRow.tax = element.tax1_rate;
        this.selectedOrderMap.set(element.order_id, newRow);

        if (newRow.totalAmount != null && newRow.totalAmount > 0) {
          this.orderBtn = true;
        }
      });

    }

  }

  // advance payment textbox format


  // Order POP up relateted methods

  GetOrderInvoiceClick(orderInvoiceid, invoice_flag) {
    // debugger;
    this.OrderInvoice = '';

    this.loadingOrderInvoicepopup = true;
    this.OrderRelatedInvoiceId = orderInvoiceid;
    this.orderInvoiceBtn = false;
    // debugger;
    // alert(this.OrderRelatedInvoiceId);
    this.agencyid = sessionStorage.getItem('AgencyID');
    if (invoice_flag === 'YES') {
      this.IsinvoicedFlag = true;
      this.externalUserService.GetOrderInvoiceGrid(this.OrderRelatedInvoiceId, this.agencyid).subscribe(
        p => { this.OrderInvoice = p, this.loadingOrderInvoicepopup = false; }
      );
      this.loading = true;
      setTimeout(() => {
        this.loading = false;
      }, 1000);
      //console.log(this.OrderInvoice);
    } else {
      this.IsinvoicedFlag = false;
    }
  }



  onOrderInvoiceRowSelect(event) {

    if(event.data.status == "Payment Processing")
      {
        event.onRowEditSelect = false;
      }
      else
        {
    let newRow = new TransactionHistory();
    newRow.orderId = this.OrderRelatedInvoiceId;
    newRow.invoiceId = event.data.invoiceID;
    newRow.invoiceDate = event.data.invoiceDate;
    newRow.agencyId = +this.agencyid;
    newRow.advertiserId = event.data.advertiserId;
    newRow.dueDate = event.data.invoiceDueDate;
    newRow.totalAmount = event.data.invoiceAmount;
    newRow.createdBy = this.userId;
   // Arvind for Station Name in report 
   newRow.station = event.data.station_name;

    this.selectedOrderInvoiceMap.set(event.data.invoiceID, newRow);

    if (newRow.totalAmount != null && newRow.totalAmount > 0) {
      this.orderInvoiceBtn = true;
    }
        }


  }
  onRowOrderInvoiceUnselect(event) {

    if (this.selectedOrderInvoiceMap.has(event.data.invoiceID)) {
      let loopStatus = 1;
      this.selectedOrderInvoiceMap.delete(event.data.invoiceID);
      this.selectedOrderInvoiceMap.forEach((value: TransactionHistory, key: any) => {
        if (loopStatus) {
          let amount = new TransactionHistory();
          amount.totalAmount = value.totalAmount;
          if (amount.totalAmount > 0) {
            this.orderInvoiceBtn = true;
            loopStatus = 0;
          }
        }
      });
      if (this.orderInvoiceBtn === true && loopStatus !== 0) {
        this.orderInvoiceBtn = !this.orderInvoiceBtn;
      }
    }

    if (this.selectedOrderInvoiceMap.size === 0) {
      this.orderInvoiceBtn = false;
    }

  }



  orderInvoiceHeaderCheckBoxToggle(selectedItems) {
    // debugger;
    this.orderInvoiceBtn = false;

    if (this.selectedOrderInvoiceMap.size > 0) {
      this.selectedOrderInvoiceMap.clear();
    }

    if (selectedItems.length > 0) {
      selectedItems.forEach(element => {

        if(element.status == "Payment Processing")
          {
            element.onRowEditSelect = false;
          }
          else
            {
        let newRow = new TransactionHistory();
        newRow.orderId = this.OrderRelatedInvoiceId;
        newRow.invoiceId = element.invoiceID;
        newRow.invoiceDate = element.invoiceDate;
        newRow.agencyId = +this.agencyid;
        newRow.advertiserId = element.advertiserId;
        newRow.dueDate = element.invoiceDueDate;
        newRow.totalAmount = element.invoiceAmount;
        newRow.createdBy = this.userId;

        this.selectedOrderInvoiceMap.set(element.invoiceID, newRow);
        if (newRow.totalAmount != null && newRow.totalAmount > 0) {
          this.orderInvoiceBtn = true;
        }
      }
      });
    }

  }


  OrderInvoiceDetail(event) {

    document.getElementById('close').click();

    this.orderInvoiceBtn = !this.orderInvoiceBtn;
    let selectedInvoices: any = [];

    this.selectedOrderInvoiceMap.forEach((value: TransactionHistory) => {
      selectedInvoices.push(value);
    });

    this.externalUserService.saveTransactionHistory(selectedInvoices).subscribe(
      p => {
        this.router.navigate(['OrderInvoiceDetail', p]);
      }
    );

  }

  GetTransaction() {
    sessionStorage.setItem("advanceID", "0");
    this.router.navigate(['TransactionRefund']);
    sessionStorage.setItem("advanceID", "0");
    this.SumStationAmount = 0;
    this.commentstxt = "";
    this.accountExtxt = null;


  }

  saveIP() {

    this.http.get<{ ip: string }>('https://jsonip.com')
      .subscribe(data => {
        this.LognewUser.IPAddress = data.ip;
        this.LognewUser.LoginTime = new Date();
        const { detect } = require('detect-browser');
        const browser = detect();
        this.LognewUser.Browsertype = browser.name;
        this.LognewUser.BrowserVersion = browser.version;
        this.LognewUser.SSO = this.authManagerService.dynSSOId;
        this.LognewUser.FirstName = sessionStorage.getItem('firstname');
        this.LognewUser.LastName = sessionStorage.getItem('lastname');
        this.LognewUser.Active = 1;
        this.LognewUser.CustomerID = this.AgencyID;
        this.LognewUser.userID = sessionStorage.getItem('userid');
        this.adminService.searchUser(this.LognewUser.userID, this.LognewUser.IPAddress, this.LognewUser.Browsertype)
          .subscribe((status) => {
            this.UserLogStatus = status;
            if (this.UserLogStatus === 'Success') {

              this.adminService.LogNewUserDetails(this.LognewUser)
                .subscribe((LogNewUserstatus) => { this.UserLogStatus = LogNewUserstatus; });
            } else {
              this.LnewUser.IPAddress = this.LognewUser.IPAddress;
              this.LnewUser.Browsertype = this.LognewUser.Browsertype;
              this.LnewUser.LogOutTime = new Date();
              this.LnewUser.Active = 0;
              this.LnewUser.SSO = this.authManagerService.dynSSOId;
              this.LnewUser.userID = this.LognewUser.userID;
              this.adminService.LogUserUpdateDetails(this.LnewUser)
                .subscribe((LogUserUpdatestatus) => { this.UserLogStatus = LogUserUpdatestatus; });

              this.adminService.LogNewUserDetails(this.LognewUser)
                .subscribe((LogNewUserstatus) => { this.UserLogStatus = LogNewUserstatus; });
            }
          });
      }, error =>
        console.error(error));
  }

  UserAgencyFilterInvoice(data) {
    //debugger;
    sessionStorage.setItem('AgencyID', data.agencyID);
    sessionStorage.setItem('agencyData', JSON.stringify(data));
    this.agencyid = sessionStorage.getItem("AgencyID");
    this.ShowInvoice = true;
    this.ShowOrder = false;
    this.ShowAdvancePayment = false;
    this.somePlaceholder = data.agencyName;

    this.ClearSelectedValues();    

    this.GridLoad(data.agencyID);
  }

  UserAgencyFilterOrder(data) {
    //debugger;
   // console.log(data);
    sessionStorage.setItem('AgencyID', data.agencyID);
    sessionStorage.setItem('agencyData', JSON.stringify(data));
    this.agencyid = sessionStorage.getItem("AgencyID");
    this.showOrder();

    this.ClearSelectedValues();

    this.GridLoad(data.agencyID);
  }
  GridLoad(agencyID) {
    this.GetOrderGrid(agencyID);
    this.GetInvoiceGrid(agencyID);
  }  
  ClearSelectedValues()
  {
    // Clear Selected Invoice Grid values
    if (this.selectedInvoiceMap.size > 0) {
      this.selectedInvoiceMap.clear();
      this.invoiceBtn = !this.invoiceBtn;
    }

    // Clear Selected Orders Grid values
    if (this.selectedOrderMap.size > 0) {
      this.selectedOrderMap.clear();
      this.orderBtn = !this.orderBtn;
    }

    // Clear Selected OrderInvoice Popup values
    if (this.selectedOrderInvoiceMap.size > 0) {
      this.selectedOrderInvoiceMap.clear();
      this.orderInvoiceBtn = !this.orderInvoiceBtn;
    }
  }

  checkMatchedData(dataCheck) {
    if (this.StationListInitial) {
      return this.StationListInitial.some((data, i) => {
        return data.station.stationName == dataCheck;
      });
    }
  }

  onAddStationClick(addForm) {
    this.isStationExist = false;
//debugger;
    //this.isStationExist = false;
    //this.isStationExist = this.checkMatchedData(addForm.value.station.stationName);

   // if (this.isStationExist) {
    //  this.isStationExist = true;
    //  return true;
   // }
   // else {
sessionStorage.setItem('selectedAccExe', JSON.stringify(this.accountExtxt));
      if (this.accountExtxt != null) {
        if (this.accountExtxt.id == null) {
          this.invalidAccountEx = false;
          this.CheckAddStation = false;
          //sessionStorage.setItem('selectedAccExe', JSON.stringify(this.accountExtxt));
        } else {

          this.invalidAccountEx = true;
          this.CheckAddStation = true;

        }
      }
      else if (this.accountExtxt == null) {
        this.invalidAccountEx = false;
        this.CheckAddStation = false;

      }
//Arvind added for agency in advance page.

if (this.selectedUserAgency == "" || this.selectedUserAgency == undefined) {
//this.invalidAgency = false;
  this.CheckAddStation = false;
} else {

  this.invalidAgency = true;
  this.CheckAddStation = true;
}

//End

      if (this.commentstxt == "" || this.commentstxt == undefined) {
        this.invalidComments = false;
        this.CheckAddStation = false;
      } else {

        this.invalidComments = true;
        this.CheckAddStation = true;
      }

      if (this.amounttxt == "" || this.amounttxt == null || this.amounttxt <=0) {

        this.exceededAdvanceAmnt = true;
        this.invalidAdvanceAmnt = false;
        this.CheckAddStation = false;

      }
else {
  if(this.amounttxt > 10000000)
          {
            this.exceededAdvanceAmnt = false;
          }
          else{
            this.exceededAdvanceAmnt = true;
          }

        this.invalidAdvanceAmnt = true;
        this.CheckAddStation = true;
      }
      //debugger;
      if (this.stationtxt == null || this.stationtxt.stationID == 0 || this.stationtxt == undefined) {
        this.invalidStation = false;
        this.CheckAddStation = false;
      }
      else {

      this.isStationExist=false;
    this.isStationExist = this.checkMatchedData(addForm.value.station.stationName);

    if(this.isStationExist){
      this.isStationExist =true;
    }

      this.invalidStation = true;
        this.CheckAddStation = true;

    }
      //else {

       // this.invalidStation = true;
       // this.CheckAddStation = true;
     // }
     // Arvind Added Agency name  condition for advance page in below line.
      if (!this.isStationExist && this.accountExtxt != null && this.selectedUserAgency != null && (this.commentstxt != "" && this.commentstxt != undefined) && this.amounttxt != null && this.amounttxt != 0 && (this.amounttxt > 0 && this.amounttxt <= 10000000) && (this.stationtxt != null && this.stationtxt != undefined)) {
        //debugger;
        sessionStorage.setItem('selectedAccExe', JSON.stringify(this.accountExtxt));

        this.station = this.stationtxt;
        this.AdvancePaymentstationsDetails.stationId = this.station.stationID;
        this.AdvancePaymentstationsDetails.amount = this.amounttxt;
        this.AdvancePaymentstationsDetails.accountExecutiveId = this.accountExtxt.id;
        this.AdvancePaymentstationsDetails.externalUserComments = this.commentstxt;
        this.AdvancePaymentstationsDetails.createdBy = sessionStorage.getItem('userid');
        this.AdvancepaymentID = + sessionStorage.getItem('advanceID');
        // Arvind Added Agency name condition for advance page in below line.
        this.AdvancePaymentstationsDetails.agencyAdvance = this.selectedUserAgency.agencyID;
        if (this.AdvancepaymentID == null || this.AdvancepaymentID == 0) {
          this.AdvancePaymentstationsDetails.advancePaymentId = 0;
        }
        else {
          this.AdvancePaymentstationsDetails.advancePaymentId = this.AdvancepaymentID;
        }

        this.AdvancePaymentstationsDetails.advancePaymentstationsId = 0;

        let Response;
        this.externalUserService.SaveAdvancePaymentstations(this.AdvancePaymentstationsDetails).subscribe(
          p => {
            Response = p;
            //debugger;
            this.ShowaddStation = false;
            this.AdvancepaymentcreatedID = JSON.parse(Response.text());
            this.AdvancepaymentID = + this.AdvancepaymentcreatedID;
            sessionStorage.setItem("advanceID", this.AdvancepaymentID.toString());
            this.GetStationGrid();
            this.getPayInformation();
			addForm.reset();
             //this.ShowpaynowBtn = true;
          }
        );
        this.GetStationGrid();
        this.ShowaddStation = false;
        this.getPayInformation();
         //this.ShowpaynowBtn = true;
      }


   // }
    this.accountExtxt = JSON.parse(sessionStorage.getItem('selectedAccExe'));


  }


 message: string;

SetMsgfortax() {
debugger;
    this.StationList.forEach(S => {

        switch (S.station.stationName) {
                    
          case 'KASA':

              this.message = 'Please process payments for New Mexico (KASA or KTEL) separately from any other station. This will ensure accurate tax calculation.';

              break;

          case 'KTEL':

              this.message = 'Please process payments for New Mexico (KASA or KTEL) separately from any other station. This will ensure accurate tax calculation.';

              break;

          case 'NTAZ':

           this.message = 'Please process payments for Telemundo Phoenix (KTAZ) or TeleXitos Phoenix (NTAZ), separately from any other station. This will ensure accurate tax calculation.';

           break;

          case 'KTAZ':

            this.message = 'Please process payments for Telemundo Phoenix (KTAZ) or TeleXitos Phoenix (NTAZ), separately from any other station. This will ensure accurate tax calculation.';

            break;

              default:
                this.message = '';

            }

    })

}
 
  GetStationGrid() {

    //debugger;
    this.AdvancepaymentcreatedID = sessionStorage.getItem('advanceID');

    //debugger;
    if (this.AdvancepaymentcreatedID != "" && this.AdvancepaymentcreatedID != null) {
      this.loadingStationGrid = true;
      //this.userId = 1// + sessionStorage.getItem('userid');
      let status;
      this.externalUserService.GetStationGrid(this.AdvancepaymentcreatedID).subscribe(
        p => {
          this.StationList = p, this.loadingStationGrid = false;
          this.StationListInitial = JSON.parse(JSON.stringify(this.StationList));
        
          this.SetMsgfortax();
         
          debugger;

         var hasMatch =false;

        for (var index = 0; index < this.StationListInitial.length; ++index) {

           var stationNamephinox = this.StationListInitial[index];

            if(stationNamephinox.station.stationName == "KTAZ" || stationNamephinox.station.stationName == "NTAZ" || stationNamephinox.station.stationName == "KASA" || stationNamephinox.station.stationName == "KTEL" ){
               hasMatch = true;
               this.ShowTaxCheckBox = true;
              //this.isTaxChecked = false;
              this.isTaxChecked =JSON.parse(sessionStorage.getItem('taxcheckbox'));
              break;
             }

              else{
                this.ShowTaxCheckBox = false;   }
}
        }
      );
      //console.log(this.StationList[0]);
    }
  }

  onRowEditSelect(event, myForm) {

    event.isEditable = true;
    if (event.isEditable == true) {
      this.saveRow = true;
      this.cancelRow = true;

    }
    this.disableINeditBtn = true; // disable  the edit btn on click 
    this.disableINdeleteBtn = true;

  }
  onCancelRowClick(row) {
    this.disableINeditBtn = false; // enable  the edit btn on cancel click
    this.disableINdeleteBtn = false;//enable the delete button on cancel click
    this.disableINUpdateBtn = false; // enable  the update btn on cancel click
    row.isEditable = false;
    this.saveRow = false;
    this.cancelRow = false;
    this.isStationExistInGrid = false;
    this.invalidAdvanceAmntInGrid = true;
    this.exceededAdvanceAmntInGrid = true;
    this.GetStationGrid();
  }

  addStation() {
    this.ShowaddStation = true;
    this.isStationExist = false;
    this.invalidStation = true;
    this.invalidAdvanceAmnt = true;
    this.exceededAdvanceAmnt = true;
  }

  showAddstationClose() {
    this.ShowaddStation = false;
    this.isStationExist = false;
    this.exceededAdvanceAmnt = true;
    this.invalidAdvanceAmnt = true;
    this.invalidStation = true;
  }

  //Method to delete internal users
  onRowINdeleteSelect(deletedstationRow) {
    this.confirmationService.confirm({
      message: 'Do you want to delete this record?',
      header: 'Delete Confirmation',
      icon: 'fa fa-trash',
      accept: () => {
        //this.deletedINuserDetails.userID = deletedInUserRow.userID;
        //this.deletedINuserDetails.isActive = false;
        //this.updateUserDetails(this.deletedINuserDetails, this.internalUserType);
        let Response;
        this.externalUserService.DeleteAdvancePaymentstation(deletedstationRow).subscribe(
          p => {
            Response = p;
            //this.ShowaddStation = false;

            this.GetStationGrid();
            this.getPayInformation();
          }

        );
      }
    });
    this.SetMsgfortax();

  }

  onUpdateStationRowClick(UpdatestationRow, index) {
    //debugger;
    this.isStationExistInGrid = false;
    this.exceededAdvanceAmnt = true;
    this.exceededAdvanceAmntInGrid = true;
this.invalidAdvanceAmntInGrid = true;

    if (UpdatestationRow.station.stationName != this.StationListInitial[index].station.stationName) {
      this.isStationExistInGrid = this.checkMatchedData(UpdatestationRow.station.stationName);
    }

    if (!UpdatestationRow.amount || UpdatestationRow.amount <= 0) {
      this.invalidAdvanceAmntInGrid = false;
    }
    if(UpdatestationRow.amount >= 10000000) 
      {
        this.exceededAdvanceAmntInGrid = false;
      }

    if (this.isStationExistInGrid) {
      return true;
    }


    else {
      if ((UpdatestationRow.amount > 0 && UpdatestationRow.amount < 10000000) && UpdatestationRow.amount != null) {


        let Response;
        this.externalUserService.UpdateAdvancePaymentstation(UpdatestationRow).subscribe(
          p => {
            Response = p;
            //this.ShowaddStation = false;
            this.GetStationGrid();
            this.getPayInformation();
          }

        );
        this.GetStationGrid();
        this.getPayInformation();
        UpdatestationRow.isEditable = false;
        this.disableINeditBtn = false;
        this.disableINdeleteBtn = false;
        this.invalidAdvanceAmntInGrid = true;
        this.exceededAdvanceAmnt = true;
        this.exceededAdvanceAmntInGrid = true;
      }
      // else {
      //   this.invalidAdvanceAmntInGrid = false;
      // }
    }


  }

  getPayInformation() {
// Arvind change FOr Userid =1;
    this.userId = +sessionStorage.getItem('userid');
    this.AdvancepaymentcreatedID = sessionStorage.getItem('advanceID');
    this.externalUserService.getPayInformation(this.AdvancepaymentcreatedID).subscribe((status) => {

      if(!status){
          return;
      }
      this.advancePaymentInfo = status;

      this.commentstxt = this.advancePaymentInfo.externalUserComments;
      let accountExecutivesTemp = JSON.parse(JSON.stringify(this.accountExecutives));
      this.accountExtxt = accountExecutivesTemp.find((data,index)=>{
        return this.advancePaymentInfo.accountExecutiveId==data.id;
      });
      this.SumStationAmount = this.advancePaymentInfo.sumAmount;
      this.AdvancepaymentID = this.advancePaymentInfo.advancePaymentId;
      //debugger;
       if(this.SumStationAmount== 0)
      {
        this.ShowpaynowBtn = false;
      }else{

         this.ShowpaynowBtn = true;
      }

    });
   
    //sessionStorage.setItem('taxcheckbox', JSON.stringify(this.ShowTaxCheckBox ));
    sessionStorage.setItem('taxcheckbox', JSON.stringify(this.isTaxChecked ));
    sessionStorage.setItem('comissioncheckbox', JSON.stringify(this.isCheckedAgency));
  }

// Arvind for Advance page check box for agency commission
onChecked(event) {
 // debugger;
  sessionStorage.setItem('comissioncheckbox', JSON.stringify(this.isCheckedAgency));
  //sessionStorage.setItem('comissioncheckbox',event.target.checked);
  console.log(event.target.checked);
  if (event.target.checked === false) {
    console.log(this.isCheckedAgency);
    //this.isCheckedAgency = false;
    this.isPayment = false;
    this.InvalidAmount = false;
   // debugger;
    this.Advancetotalamount = this.amounttxt;
  //  this.advanceAmountCC= this.AdvancetotalamountCC;
    this.paymenttype = "Partial";

    let advancePaymentDetailsId = sessionStorage.getItem('advanceID');
    this.externalUserService.updateCommsPercent(this.paymenttype, advancePaymentDetailsId).subscribe(
     p => {
      
       return p;
    
     },
   );
  } 
  else {
    //this.isCheckedAgency = true;
    this.isPayment = true;
    console.log(this.isCheckedAgency);
    this.Advancetotalamount = this.SumStationAmount;
   // this.AdvancetotalamountCC = this.advanceAmountCC;
    this.paymenttype = "Full";

    let advancePaymentDetailsId = sessionStorage.getItem('advanceID');
    this.externalUserService.updateCommsPercent(this.paymenttype, advancePaymentDetailsId).subscribe(
     p => {
      
       return p;
    
     },
   );

    
    this.reCalculateAgency(this.Advancetotalamount, this.OrderagencyID, this.paymenttype);
  }
  // Addde to have in session. removed this whhile debuggin stg and found not needed.0n May-31-2023 JDP
  //this.isCheckedAgency = JSON.parse(sessionStorage.getItem('isChecked'));
}
reCalculateAgency(event, OrderagencyID, paymenttype)
{
  let advancePaymentDetailsId = sessionStorage.getItem('advanceID');
  this.InvalidAmount = false;
  //this.InvalidAmount2 = false;
  // Button Disable
    this.isLoading = true;
    this.OrderagencyID = sessionStorage.getItem('AgencyID');
    //this.externalUserService.GetAdvanceAgencyDetail(this.Advancetotalamount, this.OrderagencyID,this.paymenttype, advancePaymentDetailsId,this.isTaxChecked).
    this.externalUserService.GetAdvanceAgencyDetail(this.Advancetotalamount, this.OrderagencyID,this.paymenttype,advancePaymentDetailsId,this.isTaxChecked,this.isCheckedAgency).subscribe(
      p => {
        //Ajay - Button Disable
        this.isLoading = false;
        this.orderAgencyDetail = p;
        // 
        sessionStorage.setItem('orderAgencyDetail',this.orderAgencyDetail);

      },
    );
}

// Arvind For Tax checkbox changes.


// onTaxChecked(event) {

//   debugger;

//    sessionStorage.setItem('taxcheckbox', JSON.stringify(this.isTaxCheckedBOX));
//      if (this.isCheckedAgency === undefined || this.isCheckedAgency=== false )
//    {
//     //this.isCheckedAgency = false;
//     this.paymenttype = "Partial";
//     this.Advancetotalamount = this.SumStationAmount;
//    }
//    else
//    {    
//     this.paymenttype = "Full";
//     this.Advancetotalamount = this.SumStationAmount;
//    }
//    let advancePaymentDetailsId = sessionStorage.getItem('advanceID');
//    this.externalUserService.updateCommsandTaxPercent(this.paymenttype, advancePaymentDetailsId,this.isTaxCheckedBOX).subscribe(
//     p => {
     
//       return p;
   
//     },
//   );
//    this.reCalculateAgencyTax(this.Advancetotalamount, this.OrderagencyID, this.paymenttype, this.isTaxCheckedBOX);
   
//  }
 

onTaxChecked(event) {

  debugger;  

   sessionStorage.setItem('taxcheckbox', JSON.stringify(this.isTaxChecked));


   if (event.target.checked == false)
   {
    this.isTaxChecked = false;

   }
else
{

  this.isTaxChecked = true;
}

     if ((this.isCheckedAgency === undefined || this.isCheckedAgency === false )&&  this.isTaxChecked == true)
   {
    //this.isCheckedAgency = false;
    this.paymenttype = "Partial";
    this.Advancetotalamount = this.SumStationAmount;
   }
   else
   {    
    this.paymenttype = "Full";
    this.Advancetotalamount = this.SumStationAmount;
   }
   let advancePaymentDetailsId = sessionStorage.getItem('advanceID');
   this.externalUserService.updateCommsandTaxPercent(this.paymenttype, advancePaymentDetailsId,this.isTaxChecked).subscribe(
    p => {
     
      return p;
   
    },
  );
   this.reCalculateAgencyTax(this.Advancetotalamount, this.OrderagencyID, this.paymenttype, this.isTaxChecked);
   
 }
 
 reCalculateAgencyTax(event, OrderagencyID, paymenttype,isTaxChecked)
 {
  let advancePaymentDetailsId = sessionStorage.getItem('advanceID');
   this.InvalidAmount = false;
   console.log("Arvind 2");
   this.isTaxChecked =JSON.parse(sessionStorage.getItem('taxcheckbox'));
   console.log(this.isTaxChecked + 'Comment in reCalculateAgencyTax');
     this.isLoading = true;
     this.OrderagencyID = sessionStorage.getItem('AgencyID');
    // this.externalUserService.GetAdvanceAgencyDetail(this.Advancetotalamount, this.OrderagencyID,this.paymenttype, advancePaymentDetailsId,this.isTaxChecked)
     this.externalUserService.GetAdvanceAgencyDetail(this.Advancetotalamount, this.OrderagencyID,this.paymenttype,advancePaymentDetailsId,this.isTaxChecked,this.isCheckedAgency).subscribe(
       p => {
        
         this.isLoading = false;
         this.orderAgencyDetail = p;
      
       },
     );
 }

}



// WEBPACK FOOTER //
// ./src/app/external-user/external-user.component.ts